import React, { useEffect, useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/auth.store';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const location = useLocation();

  // Track previous auth state so we can distinguish:
  //   (a) sign-out / session-expiry  → was true, now false → send to /welcome
  //   (b) cold unauthenticated access → was false, still false → send to /sign-in?redirect=
  const wasAuthenticated = useRef(isAuthenticated);
  useEffect(() => {
    wasAuthenticated.current = isAuthenticated;
  });

  if (!isAuthenticated) {
    if (wasAuthenticated.current || location.pathname === '/') {
      return <Navigate to="/welcome" replace />;
    }
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/sign-in?redirect=${redirect}`} replace />;
  }

  return <>{children}</>;
}

export function PublicRoute({ children }: ProtectedRouteProps) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
